export const appBuildAssetsDir = "lp/build/assets"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"Professionelle Fotoboxen für Hochzeiten, Geburtstage und Firmenfeiern in Berlin. ✓ Mit Drucker ✓ Requisiten ✓ Sofortiger Ausdruck"},{"name":"robots","content":"index, follow"},{"property":"og:locale","content":"de_DE"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/static/assets/logo.png"}],"style":[],"script":[{"children":"\n            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer','GTM-PNSGFKVM');\n          ","type":"text/javascript"},{"async":true,"defer":true,"src":"https://umami.msb28.com/script.js","data-website-id":"0ab1ef07-761c-4aab-957d-77492253fbc0"}],"noscript":[{"children":"\n            <iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-PNSGFKVM\"\n              height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>\n          ","tagPosition":"bodyOpen"}],"htmlAttrs":{"lang":"de"},"charset":"utf-8","viewport":"width=device-width, initial-scale=1","title":"Fotobox mieten Berlin | mietfotobox.com"}

export const appBaseURL = "/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true